import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							Let's Collaborate: Reach Out Through These Channels
						</div>

						<div className="subtitle contact-subtitle">
							I appreciate you reaching out. For project inquiries, collaborations, or technical discussions, 
							you can email me directly at {" "}
							<a href={`mailto:${INFO.main.email}`}>
								{INFO.main.email}
							</a>
							. I typically respond to professional inquiries within 24 hours on business days. 
							For quick questions or networking, feel free to connect with me on {" "}
							<a
								href={INFO.socials.linkedIn}  // Changed from Instagram to LinkedIn for professional context
								target="_blank"
								rel="noreferrer"
							>
								LinkedIn
							</a>
							{" "}where I share industry insights and project updates. Looking forward to 
							connecting about potential opportunities or sharing knowledge in our field.
							</div>
					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
